import { FormSubmission } from './../../payload-types'
import { CollectionSlug, GlobalSlug } from 'payload'
import {
  BookCopy,
  Footprints,
  Image,
  LayoutGrid,
  List,
  LucideProps,
  Menu,
  Percent,
  PlusSquare,
  Redo2,
  Search,
  Smile,
  Star,
  StickyNote,
  TabletSmartphone,
  TextCursorInput,
  User,
  Building,
  Users,
  MapPin,
  Video,
  Bell,
  ClipboardList,
} from 'lucide-react'
import { ExoticComponent } from 'react'

export const navIconMap: Partial<
  Record<CollectionSlug | GlobalSlug, ExoticComponent<LucideProps>>
> = {
  categories: List,
  customers: Users,
  requests: ClipboardList,
  notifications: Bell,
  devices: TabletSmartphone,
  discountCodes: Percent,
  media: Image,
  orders: BookCopy,
  pages: StickyNote,
  posts: LayoutGrid,
  reviews: Star,
  users: User,
  videos: Video,
  country: MapPin,
  properties: Building,
  agency: Users,
  forms: BookCopy,
  redirects: Redo2,
  'form-submissions': TextCursorInput,
  search: Search,
  header: Smile,
  mainMenu: Menu,
  footer: Footprints,
  Properties: PlusSquare,
}
export const getNavIcon = (slug: string) =>
  Object.hasOwn(navIconMap, slug) ? navIconMap[slug as CollectionSlug | GlobalSlug] : undefined
